<template>
 <div class="register">
       <section class="hero">
         <div class="hero-body">
         <div class="container">
           <h1 class="title is-large is-primary is-bold">Sign Up</h1>
           <h2 class="subtitle">The journey to the body of your dreams starts here</h2>
         </div>
         <section class="form">
           <div class="field">
             <div class="control">
               <button class="button is-success is-danger">Sign Up With Google</button>
             </div>
           </div>

           <div class="field">
            <div class="control">
              <input class="input" type="email" placeholder="Start with email">
            </div>
          </div>
          <div class="control">
              <input class="input" type="password" placeholder="Choose a password">
            </div>

            <p class="control is-small haveaccount">Already have an account? 
              <span> 
              <router-link to="/login" class="is-large">Login</router-link>
              </span>
              </p>
         </section>
         </div>
       </section>
 </div>
</template>

<script>
// @ is an alias to /src

export default {
  name:'register',
  components: {
  }
}
</script>

<style lang="scss" scoped>
.register{
  background:url(../assets/body3.jpg);
  background-size:cover;
  height:fit-content;
  min-height:100vh;
}
a{
  color:hotpink;
  text-decoration:underline;
}
.hero{
 padding-top:14rem;
}
.title{
  color:#fff;
  font-size:3.5rem;
  font-family:monospace;
}
.title::after{
  content:'.';
  font-size:2.5rem;
  border-radius: 50%;
}
.subtitle{
  color:#fff;
  padding-top:1.5rem;
  font-size:1.5rem;
  font-weight:400;
  font-family: 'Times New Roman', Times, serif;
}
.form{
  margin-top:2.5rem;
}
.haveaccount{
  color:#fff;
  margin-top: .75rem;
}
.input::placeholder{
  color:hsl(0, 0%, 0%);
  opacity:1;
  font-family: sans-serif;
  font-size:.8rem;
}
</style>
